import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";

const AboutSummerResidency2027 = () => {
  useEffect(() => {
    document.title = "About Summer Residency 2027 - MS Digital Hub";
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      <Box
        sx={{
          width: "auto",
          padding: "0px 20px",
          margin: "0px auto",
          padding: { xs: "20px", sm: "30px", md: "1px 80px" },
          border: "none",
          backgroundColor: "#ffffff",
          borderRadius: "8px",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            marginBottom: "30px",
            textAlign: "center",
          }}
        >
          Summer Residency 2027
        </Typography>

        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          High school teachers at all Mississippi schools are invited to apply
          for a two-week summer residency hosted by The University of Southern
          Mississippi&apos;s Digital Humanities Hub. Participants will learn the
          basics of digitization and the digital humanities from experts
          affiliated with the Center for Digital Humanities at Southern Miss and
          discover opportunities to incorporate digital storytelling into their
          lesson plans and classrooms.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          Digital Humanities is an evolving field that uses computers to explore
          scholarly questions in the humanities (English, history, philosophy,
          and similar subjects). Digital Humanists use a wide range of tools,
          such as mapping, data visualization, text analysis, digital exhibits,
          and digital storytelling, to engage students and preserve local
          history and culture.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          The two-week residential course for{" "}
          <strong>Mississippi teachers only</strong> will take place from
          Monday, June 14, 2027, through Friday, June 25, 2027. Applications
          open November 1, 2026, and are due by 11:59 PM (CT) on March 15, 2027.
          Participation is limited to ten teachers.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          All participants will be provided with housing, most meals, travel
          reimbursement, and small stipends. In addition to learning digital
          tools and methods, teachers enrolled in the summer residency will
          explore the cultural and historical sites of Hattiesburg and the
          surrounding communities.
        </Typography>
      </Box>
    </motion.div>
  );
};

export default AboutSummerResidency2027;
